import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const MinLengthMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Min extends Clazz {
    @Input()
    minLength!: number;

    @Output()
    public minLengthChange = new EventEmitter<boolean>();
  }

  return Min;
};

export const MinLengthMixinInputs = ["minLength"];
